import React from "react";
import { CheckCircle2, AlertCircle, Clock, TrendingUp, MinusCircle } from "lucide-react";

const config = {
  paid: { cls: "pill-paid", label: "Paid", icon: CheckCircle2 },
  overdue: { cls: "pill-overdue", label: "Overdue", icon: AlertCircle },
  due_soon: { cls: "pill-due", label: "Due Soon", icon: Clock },
  unpaid: { cls: "pill-due", label: "Unpaid", icon: Clock },
  upcoming_increase: { cls: "pill-inc", label: "Increase", icon: TrendingUp },
  partial: { cls: "pill-due", label: "Partial", icon: MinusCircle },
  active: { cls: "pill-paid", label: "Active", icon: CheckCircle2 },
  ended: { cls: "pill-muted", label: "Ended", icon: MinusCircle },
};

export default function StatusPill({ status, label }) {
  const c = config[status] || config.unpaid;
  const Icon = c.icon;
  return (
    <span className={`pill ${c.cls}`} data-testid={`status-pill-${status}`}>
      <Icon className="w-3 h-3" />
      {label || c.label}
    </span>
  );
}
